'use client';

import React from 'react';
import { Chip } from '@heroui/react';
import { RevshareTransaction } from '../types';
import { useTranslations } from '../../../../contexts/translation.context';
import Typography from '../../../../components/typography/Typography';

interface StatusCellProps {
  transaction: RevshareTransaction;
}

const StatusCell: React.FC<StatusCellProps> = ({ transaction }) => {
  const { t } = useTranslations();
  const statusRaw = (transaction.status || transaction.company_status || '').toLowerCase().trim();

  const getStatusConfig = () => {
    switch (statusRaw) {
      case 'done':
      case 'completed':
      case 'loaded':
        return {
          dot: 'bg-success',
          label: t('partner.revshare.transactions.filters.statusCompleted'),
        };
      case 'undo':
      case 'returned':
      case 'canceled':
      case 'cancelled':
        return {
          dot: 'bg-danger',
          label: t('partner.revshare.transactions.filters.statusCancelled'),
        };
      case 'loading':
      case 'waiting':
      default:
        return {
          dot: 'bg-neutral-400',
          label: t('partner.revshare.transactions.filters.statusWaiting'),
        };
    }
  };

  const statusConfig = getStatusConfig();

  return (
    <Chip
      className="bg-gray-100 text-gray-900"
      classNames={{
        base: 'h-6 px-2 py-1 gap-1',
      }}
      size="sm"
      startContent={<div className={`w-2 h-2 rounded-full ${statusConfig.dot}`} />}
    >
      <Typography variant="body3" className="text-gray-900">
        {statusConfig.label}
      </Typography>
    </Chip>
  );
};

export default StatusCell;

